import { queryOptions, useQuery } from "@tanstack/react-query"

import { axiosInstance } from "@/lib/api-client"
import { API_ROUTES } from "@/lib/api-routes"
import type { NodeRole, PlanPublic } from "../types"

/**
 * Every active public plan (capacity + price only), each with the regions
 * it deploys to — one call for all three roles. Effectively static, so we
 * keep it fresh for a while.
 */
export function publicPlansQueryOptions() {
  return queryOptions({
    queryKey: ["plans"],
    queryFn: async () => {
      const res = await axiosInstance.get<PlanPublic[]>(API_ROUTES.PLANS)
      return res.data
    },
    staleTime: 5 * 60 * 1000,
  })
}

/** All plans, or those for one role. Empty list → that role can't be ordered. */
export function usePublicPlansQuery(role?: NodeRole) {
  return useQuery({
    ...publicPlansQueryOptions(),
    select: role ? (plans) => plans.filter((p) => p.role === role) : undefined,
  })
}
